import appReducer from './appReducer';
import localForage from 'localforage';
import analytics from '@/analytics';
import { cache } from '@/store';
import { removeAuthToken } from '@/config/settings';
import { clearCache } from '@growthbook/growthbook';

const rootReducer = (state, action) => {
  if (action.type === 'LOGOUT') {
    localForage.clear();
    sessionStorage.clear();
    cache.clear();
    if (window.Intercom) window.Intercom('shutdown');
    removeAuthToken();
    analytics.shutdown();
    clearCache().catch(e => {
      console.log('Could not clear growthbook cache', e);
    });
  }

  return appReducer(state, action);
};

export default rootReducer;
